import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class UsedTypeSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let children = []
    children.push(<Option key='original'>Selling Original</Option>)
    children.push(<Option key='commission'>Take Commission</Option>)
    children.push(<Option key='prints'>Available for Prints</Option>)
    children.push(<Option key='licensing'>Licensing</Option>)

    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select business type'
        {...this.props}
        mode='multiple'
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
      >
        {children}
      </Select>
    )
  }
}

export default UsedTypeSelect
